module.exports = __webpack_public_path__ + "img/logo.19d3ebaa.png";